var nav = document.querySelector('.top-nav__right');
var toggle = document.querySelector('.top-nav__toggle');

toggle.addEventListener('click', function () {
  toggle.classList.toggle('active');
  nav.classList.toggle('active');
});